import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { MoonIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 bg-navy-800 relative border-y border-navy-700" data-id="element-254">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-255">
        <FadeIn data-id="element-256">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-navy-900 border border-navy-700 mb-8 box-glow" data-id="element-257">
            <MoonIcon className="w-5 h-5 text-gold-400" data-id="element-258" />
          </div>

          <div className="space-y-6 text-body-xl font-serif italic text-cream leading-relaxed" data-id="element-259">
            <p data-id="element-260">
              "Son las 3:15 de la mañana. Tus ojos están abiertos, tu cuerpo se
              siente como si pesara una tonelada, pero tu mente no se detiene.
              Calculas cuántas horas te quedan antes de que suene la alarma y
              sientes esa punzada de ansiedad en el pecho."
            </p>
            <p className="text-cream-muted text-body-lg not-italic font-sans" data-id="element-261">
              Sabes que mañana será otro día de "niebla mental", de mal humor y
              de sobrevivir a punta de café. Has intentado tés, melatonina y
              música relajante, pero nada parece apagar ese interruptor que te
              mantiene alerta cuando más necesitas descansar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}